import { useCallback } from "react";
import { useWeb3React } from "../useWagmiCompat";
import useWeb3 from "../useWeb3";
import { chinaContract } from "../../utils/contractHelpers";
import Environment from "../../utils/Environment";

const useClaim1 = () => {
  const { account } = useWeb3React();
  const web3 = useWeb3();

  const tokenAddress = Environment.presaleContract;
  const contract = chinaContract(tokenAddress, web3);

  const claim1 = useCallback(
    async (amount) => {
      if (!account) {
        throw new Error("WALLET_NOT_CONNECTED");
      }

      try {
        return new Promise(async (resolve, reject) => {
          let gas;

          try {
            gas = await contract.methods
              .claimTomi(amount)
              .estimateGas({ from: account });
          } catch (err) {
            return reject(err);
          }

          contract.methods
            .claimTomi(amount)
            .send({ from: account, gas })

            /* (optional) tx hash */
            .on("transactionHash", (hash) => {
              console.log("Claim tx hash:", hash);
            })

            /* ✅ RESOLVE ONLY ON RECEIPT */
            .on("receipt", (receipt) => {
              console.log("Claim confirmed:", receipt);
              resolve({
                transactionHash: receipt?.transactionHash,
              });
            })

            /* ❌ ERROR */
            .on("error", (error) => {
              console.error("Claim error:", error);
              reject(error);
            });
        });
      } catch (error) {
        throw error;
      }
    },
    [account, contract]
  );

  return { claim1 };
};

export default useClaim1;

// import { useCallback, useState } from "react";
// import useWeb3 from "../useWeb3";
// import { chinaContract } from "../../utils/contractHelpers";
// import { useWeb3React } from "../useWagmiCompat";
// import Environment from "../../utils/Environment";

// const Claim1 = () => {
//   const [balance, setBalance] = useState(null);
//   const { account } = useWeb3React();
//   const web3 = useWeb3();
//   const tokenAddress = Environment.presaleContract;
//   const contract = chinaContract(tokenAddress, web3);

//   const claim1 = useCallback(
//     async (amount) => {
//       try {
//         const gas = await contract.methods.claimTomi(amount).estimateGas({
//           from: account,
//         });
//         const details = await contract.methods.claimTomi(amount).send({
//           from: account,
//           gas,
//         });
//         return details;
//       } catch (error) {
//         throw error;
//       }
//     },
//     [contract, account]
//   );
//   return { claim1: claim1 };
// };
// export default Claim1;
